import styled from "styled-components";

export const ConsolePageModalHeaderContainer = styled.div`
  padding: 12px 24px;

  border-bottom: 1px solid
    ${({ theme }) => theme.console.comments.cardsBorderColor};

  display: flex;
  justify-content: space-between;
  align-items: center;

  font: 500 1rem/150% Inter, sans-serif;
  color: ${({ theme }) => theme.console.pageTitleColor};

  button {
    padding: 0;
    color: inherit;
  }

  svg * {
    stroke: ${({ theme }) => theme.console.pageTitleColor};
  }
`;
